import styled from 'styled-components';

const LoginInputStyled = styled.div`
  position: relative;
`;

export default LoginInputStyled;
